export class RestoreSecurityGroups {
    'region';
    'securityGroups';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "securityGroups",
            "baseName": "securityGroups",
            "type": "Array<RestoreSecurityGroupsSecurityGroupsInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreSecurityGroups.attributeTypeMap;
    }
    constructor() {
    }
}
